import React, { Component } from 'react'
import { BrowserRouter, Route } from 'react-router-dom';
import DataTable from '../../../components/DataTable/DataTable';
import OnlineThemeForm from './OnlineThemeForm';
import TitleHeader from '../../../components/TitleHeader/TitleHeader'

class OnlineTheme extends Component {
    render() {
        const columns = [
            { label: 'ชื่อธีม', align: 'left', name: 'name', search_type: 'string' },
        ];

        const api_url = '/master/sectiononline';

        return (
            <BrowserRouter>
                <div>
                    <TitleHeader program_name='บริหารจัดการธีมลงทะเบียนออนไลน์' program_type='ข้อมูลบัญชีผู้ใช้งาน'></TitleHeader>
                    
                    <Route exact path={`${this.props.match.path}/`} component={() => (<DataTable allow_import={false} columns={columns} allow_active={true} url={api_url}></DataTable>)} />
                    
                    <Route path={`${this.props.match.path}/create`} component={props => (<OnlineThemeForm {...props} url={api_url}></OnlineThemeForm>)} />
                    <Route path={`${this.props.match.path}/:id/edit`} component={props => (<OnlineThemeForm {...props} url={api_url}></OnlineThemeForm>)} />
                </div>
            </BrowserRouter>
        )
    }
}

export default OnlineTheme
